import { useState, useContext } from 'react'
import { Handle, Position, useReactFlow } from '@xyflow/react';
import EditIcon from '@mui/icons-material/Edit';
import HubIcon from '@mui/icons-material/Hub';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import CheckIcon from "@mui/icons-material/Check";

function WorkflowEndNode({ id, data }) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node end"  + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
            <Handle type="target" position={Position.Top} />
            <span>{ "End" }</span>
        </div>
    );
}

export default WorkflowEndNode;